import React, {Component} from 'react';
import {
    Button,
    Modal,
    Form,
} from 'semantic-ui-react';
import Alert from "../../components/extras/Alert";

import connect from "react-redux/es/connect/connect";
import {showToast} from "../../actions/ToastAction";
import {productRecipesDialog} from "../../actions/ProductRecipesDialogActions";
import helpers from "../../functions/helpers";
import RecipeData from "../../data/RecipeData";
import update from "react-addons-update";
import IngredientData from "../../data/IngredientData";
import localDB from "../../data/localDB";
import WarehouseStockData from "../../data/WarehouseStockData";
import {selectProduct} from "../../actions/ProductSelectActions";

const c = require("../../constants");

class WarehouseStockDialog extends Component {

    constructor(props) {
        super(props);

        this.state = {
            options_recipes: [],
            options_products: [],
            options_ingredients: [],
            compound_error: false,
            quantity_error: false,
            data:{
                compound:null,
                quantity:1,
                type:'product'
            },
            loading: false,
            id: null,
        };
        this.loadData = this.loadData.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleTypeChange = this.handleTypeChange.bind(this);
    }

    componentWillMount(){
        this.loadData();
    };


    loadData() {
        RecipeData.getAll((options) => this.setState({options_recipes: helpers.mapOptionsWithName(options)}))

        IngredientData.list().then(ingredients => {
            let options_ingredients = ingredients.map(ingredient => {
                return {key:ingredient.id, value:ingredient.id, text:`${ingredient.name} - ${c.UNITS.find((unit) => unit.key===ingredient.unit).text}`}
            });
            this.setState({options_ingredients});
        });

        localDB.getDB('products').then(products => {
            let options_products = products.filter(product => {return product.id !== this.props.modal.id}).map(product => {return {key:product.id, value:product.id, text:product.name}});
            this.setState({options_products});
        });
    };

    handleClose = () => {
        this.setState({
            id: null,
            loading: false,
            data:{
                compound:null,
                quantity:1,
                type:'product'
            }
        });
        this.props.productRecipesDialog({
            is_open:false,
            loading:false,
            id:null
        });
    };

    handleChange = (e, { name, value }) => {
        let data = this.state.data;
        data[name]= value;
        this.setState({data, compound_error:false, quantity_error:false});
    };

    handleTypeChange = (result) => {
        let compound = update(this.state, {
            data: {
                type:  {$set: result},
                compound: {$set: null},
            }
        });
        this.setState(compound);
    };

    async handleSubmit() {
        if(this.state.data.compound === null){
            this.setState({compound_error:true});
        }else if(this.state.data.quantity <= 0){
            this.setState({quantity_error:true});
        }else {
            let data = this.state.data;
            data.product = this.state.id;
            this.add(data);
        }
    };

    async add(data) {
        this.setState({loading:true});
        WarehouseStockData.add(data, (res) => {
            if (res.save) {
                this.props.selectProduct(res.data);
                this.props.showToast({message: 'Inventario Actualizado!', type: 'success'});
                this.handleClose()
            } else {
                this.props.showToast({
                    show:true,
                    type:'error',
                    message:'Este elemento ya está en la lista!'
                });
            }
            this.setState({loading:false});
        });
    };

    render() {
        return (
            <div>
                <Modal open={this.props.modal.is_open} dimmer='inverted' size='tiny' onClose={this.handleClose}>
                    <Modal.Header>Inventario</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Form onSubmit={this.handleSubmit}>
                                <Form.Dropdown
                                    label={'Categoría'}
                                    options={c.WAREHOUSE_STOCK_TYPES}
                                    value={this.state.data.type}
                                    compact
                                    selection
                                    onChange={(e, {value}) => this.handleTypeChange(value)}
                                    placeholder='Categoría'
                                    error={this.state.type_error}
                                />
                                <Form.Dropdown
                                    label={this.state.data.type === 'product' ? 'Producto':this.state.data.type === 'ingredient' ? 'Ingrediente':'Receta'}
                                    options={this.state.data.type === 'ingredient' ?
                                        this.state.options_ingredients:this.state.data.type === 'product' ?
                                            this.state.options_products:this.state.options_recipes}
                                    placeholder={this.state.data.type === 'product' ? 'Producto':this.state.data.type === 'ingredient' ? 'Ingrediente':'Receta'}
                                    name='compound'
                                    onChange={this.handleChange}
                                    search
                                    selection
                                    error={this.state.compound_error}
                                />
                                <Form.Input
                                    label='Cantidad'
                                    placeholder='Cant.'
                                    type='number'
                                    name='quantity'
                                    min={1}
                                    step={'.01'}
                                    value={this.state.data.quantity}
                                    onChange={this.handleChange}
                                    error={this.state.quantity_error}
                                />
                            </Form>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleClose} content="Cerrar"/>
                        <Button primary icon='save'
                                labelPosition='left'
                                onClick={this.handleSubmit}
                                disabled={this.state.loading}
                                loading={this.state.loading}
                                content='Agregar'/>
                    </Modal.Actions>
                </Modal>
                <Alert ref='alert'/>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        productRecipesDialog(modal) {
            dispatch(productRecipesDialog(modal))
        },
        showToast(alert) {
            dispatch(showToast(alert));
        },
        selectProduct(data){
            dispatch(selectProduct(data))
        }
    }
}

function mapStateToProps(state) {
    return {
        modal: state.get('product_recipes_dialog'),
    };
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(WarehouseStockDialog)


// WEBPACK FOOTER //
// ./src/components/inventories/WarehouseStockDialog.js